import { Alert, Box, Snackbar, Typography } from "@mui/material"
import { COLORS } from "../../Styles/Colors"



const CustomSnackbar = ({ open, snackbarData, onClose }: any) => {

    const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === "clickaway") {
      return;
    }
    onClose(); 
  };

    return (


         <Snackbar
              open={open}
              autoHideDuration={6000}
              onClose={handleClose}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
              sx={{
                zIndex: 99999,
                bottom: { xs: 80, sm: 24 },
                left: { xs: 16, sm: 'auto' },
                right: { xs: 16, sm: 24 },
              }}
            >
              <Alert
                variant="filled"
                onClose={handleClose}
                severity={snackbarData.severity}
                sx={{
                  width: '100%',
                  border: `1px solid ${snackbarData.severity == "success" ? COLORS.darkTeal : snackbarData.severity == "error" ? COLORS.red : ""}`,
                  color: "white",
                  backgroundColor: `${snackbarData.severity == "success" ? COLORS.darkTeal : snackbarData.severity == "error" ? COLORS.red : ""}`,
                  boxShadow: '0px 3px 8px rgba(0, 0, 0, 0.15)',
                  borderRadius: '8px',
                  '& .MuiAlert-icon': {
                    alignItems: 'center',
                    display: 'flex',
                    fontSize: '24px',
                    marginRight: '12px',
                  },
                  '& .MuiAlert-message': {
                    padding: '3px 0',
                  },
                  '& .MuiAlert-action': {
                    paddingTop: '2px',
                  }
                }}
              >
                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                
                {snackbarData.title ?   <Typography variant="body2" sx={{ fontWeight: 600, lineHeight: 1.2 }}>
                    {snackbarData.title}
                  </Typography>: ""}

                 
                  <Typography variant="caption" sx={{ opacity: 0.9, mt: 0.3 }}>
                       {snackbarData.message}
                  </Typography>
                </Box>
              </Alert>
            </Snackbar>
        
    )
}

export default CustomSnackbar;